export const getVisibilityTypeOptions = () => [
  { text: "Global", value: "global" },
  { text: "Agency", value: "agency" },
  { text: "Corporate", value: "corporate" },
];

export const getVisibilityTypeMapping = type => {
  switch (type) {
    case "Public":
    case "Global":
      return "global";
    case "Agency":
      return "agency";
    case "Corporate":
      return "corporate";
  }
};
